import xhr from 'live/services/xhr'
const URL = '/services/plugin-petrobras/rigSupervisorsManagement'

let defaultErrorCallback = function (resp, errorCallback) {
    let errorResponse = resp

    if (errorResponse.data) {
        errorResponse = errorResponse.data

        if (errorResponse.message)
            errorResponse = errorResponse.message
        else if (errorResponse.error)
            errorResponse = errorResponse.error
    } else if (errorResponse.error) { errorResponse = errorResponse.error }

    console.error(errorResponse)

    if (errorCallback)
        errorCallback(errorResponse)
}

const api = {
    get (callback, errorCallback) {
        xhr.get(URL)
            .then((resp) => {
                callback(resp.data)
            })
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    getRigsEdit (callback, errorCallback) {
        xhr.get(URL + '/rigs/edit')
            .then((resp) => {
                callback(resp.data)
            })
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    save (config, rigs, callback, errorCallback) {
        xhr.put(URL + '/save', {config, rigs: JSON.stringify(rigs)})
            .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    testCalculations (rigs, config, callback, errorCallback) {
        xhr.post(URL + '/testCalculations', {rigs: rigs, config: config})
            .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    createDIP (startDate, endDate, callback, errorCallback) {
        let payload = {
            'startDateStr': startDate,
            'endDateStr': endDate
        }

        xhr.post(URL + '/createDIP', payload)
            .then((resp) => {
                callback(resp.data)
            })
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    }
}

export default api
